export default __webpack_public_path__ + "static/media/wordswarmup_standard.3911637e.svg";